var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamingPad01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gaming-pad-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Solid",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1657 10.8408H27.6693C24.2645 10.8408 21.5516 10.8408 19.3528 11.015C17.0973 11.1936 15.1673 11.5673 13.3752 12.4326C10.4727 13.8341 8.06121 16.0795 6.45649 18.8747C5.46567 20.6006 4.95547 22.4991 4.61657 24.7361C4.28617 26.917 4.09291 29.6229 3.85034 33.0191L3.18627 42.3162C2.75431 48.3636 7.54388 53.5075 13.6067 53.5075C16.7072 53.5075 19.6474 52.1303 21.6323 49.7485L22.6327 48.548C23.6072 47.3787 23.9 47.0414 24.2067 46.7803C24.9348 46.1602 25.8163 45.7474 26.7587 45.585C27.1557 45.5166 27.6022 45.5075 29.1243 45.5075H34.7107C36.2327 45.5075 36.6793 45.5166 37.0762 45.585C38.0187 45.7474 38.9002 46.1602 39.6283 46.7803C39.935 47.0414 40.2278 47.3787 41.2022 48.548L42.2027 49.7485C44.1875 52.1303 47.1278 53.5075 50.2283 53.5075C56.2911 53.5075 61.0807 48.3636 60.6487 42.3162L59.9846 33.019C59.7421 29.6228 59.5488 26.917 59.2184 24.7361C58.8795 22.4991 58.3693 20.6006 57.3785 18.8747C55.7738 16.0795 53.3623 13.8341 50.4598 12.4326C48.6677 11.5673 46.7377 11.1936 44.4822 11.015C42.2833 10.8408 39.5705 10.8408 36.1657 10.8408ZM23.9176 24.1742C23.9176 22.7014 22.7237 21.5075 21.251 21.5075C19.7782 21.5075 18.5843 22.7014 18.5843 24.1742V26.8408H15.9176C14.4449 26.8408 13.251 28.0347 13.251 29.5075C13.251 30.9802 14.4449 32.1742 15.9176 32.1742H18.5843V34.8408C18.5843 36.3136 19.7782 37.5075 21.251 37.5075C22.7237 37.5075 23.9176 36.3136 23.9176 34.8408V32.1742H26.5843C28.0571 32.1742 29.251 30.9802 29.251 29.5075C29.251 28.0347 28.0571 26.8408 26.5843 26.8408H23.9176V24.1742ZM37.251 32.1742C37.251 30.7014 38.4449 29.5075 39.9176 29.5075H39.9443C41.4171 29.5075 42.611 30.7014 42.611 32.1742C42.611 33.6469 41.4171 34.8408 39.9443 34.8408H39.9176C38.4449 34.8408 37.251 33.6469 37.251 32.1742ZM45.251 26.8408C45.251 25.3681 46.4449 24.1742 47.9176 24.1742H47.9443C49.4171 24.1742 50.611 25.3681 50.611 26.8408C50.611 28.3136 49.4171 29.5075 47.9443 29.5075H47.9176C46.4449 29.5075 45.251 28.3136 45.251 26.8408Z",
    fill: "url(#paint0_linear_2718_95473)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2718_95473",
    x1: 3.15918,
    y1: 53.5075,
    x2: 43.9913,
    y2: -1.53602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3377E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#23BFEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamingPad01);
export default __webpack_public_path__ + "static/media/gaming-pad-01.fa77877a715beb40190821471c28be03.svg";
export { ForwardRef as ReactComponent };